import type { ShouldRevalidateFunction } from 'react-router';

/**
 * Canonical RR7 single-fetch leaf-route revalidation policy.
 *
 * Applies to leaf routes mounted under a layout that SKIPS revalidation —
 * `_app.tsx` on same-path search-only changes (pagination / filtering), or the
 * `/articles` and `/professional/<seg>` layouts on same-subtree navigation.
 * Such a leaf must declare its own policy rather than rely on the default, so
 * that pagination and filter changes still fetch fresh leaf data. Every
 * paginated or filtered leaf under such a layout needs this policy (the
 * articles routes, the professional tabs, and the professionals directory).
 *
 * Opt every such leaf in explicitly: revalidate on GET navigation — pagination
 * and filter changes need fresh leaf data anyway — and skip on form actions,
 * which post elsewhere and must not re-run the leaf loader.
 */
export const shouldRevalidateLeaf: ShouldRevalidateFunction = ({
    formAction,
}) => {
    if (formAction) {
        return false;
    }
    return true;
};
